import React from 'react';
import { ServiceUsage } from '../../../types/resources/ServiceUsageType';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType';
import { convertDateTime } from '../../../utils/dateTime';
import { TableRoot } from '../../common/Table/TableBase/TableRoot';
import styles from './styles.module.scss';

interface ServiceUsageTableContentProps {
  columns: ActionTableColumnsType[];
  rows: ServiceUsage[];
  sortParams: ActionTableSortParamsType;
  headerSort: (column: string) => void;
}

export const ServiceUsageTableContent: React.FC<ServiceUsageTableContentProps> = ({
  columns,
  rows,
  sortParams,
  headerSort,
}) => {
  const getNestedValue = (obj: ServiceUsage, path: string) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  };

  const tableRows =
    rows !== undefined ? (
      rows.map((row: ServiceUsage, key: number) => (
        <tr key={key} className={styles.tableRow} data-testid={`table-row-${key}`}>
          {columns.map((column, columnIndex) => (
            <td
              key={column.key}
              className={styles.tableCell}
              data-testid={`table-cell-${columnIndex === 0 ? 'no' : column.key}`}
            >
              {column.key === 'created_at'
                ? convertDateTime(getNestedValue(row, column.key))
                : (getNestedValue(row, column.key) ?? '-')}
            </td>
          ))}
        </tr>
      ))
    ) : (
      <></>
    );

  return (
    <>
      {rows?.length === 0 || rows === null ? (
        <div className={styles.emptyTable}>データなし</div>
      ) : (
        <TableRoot
          columns={columns}
          rows={tableRows}
          sortParams={sortParams}
          onClickHeader={headerSort}
        />
      )}
    </>
  );
};
